// extracted by mini-css-extract-plugin
export default {"container":"lJ-z","dimension":"mJ-z","dimensionLabels":"nJ-z"};